module.exports = {
      id: "promo_material-usage",
      viewBox: "0 0 353.6 353.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#promo_material-usage",
      toString: function () {
        return this.url;
      }
    }